/**
 * Same breakpoint as the app shell:
 * - below md → burger menu (mobile header)
 * - md+ → left icon rail
 * Guided demo follows that split (not “touch vs mouse”).
 */
export const APP_MOBILE_LAYOUT_MQ = '(max-width: 767px)';

/** Sync check — safe in ensureDemoWorkspace (no React). SSR → false. */
export function isBurgerNavLayout(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(APP_MOBILE_LAYOUT_MQ).matches;
}
